
































import { Component, Prop, Vue } from "vue-property-decorator";

const BUTTON_CONFIG = {
  DEFAULT_TEXT: "Salva",
  DEFAULT_LOADING_TEXT: "Salvataggio...",
  DEFAULT_TYPE: "button",
  DEFAULT_CLASS: "btn btn-primary",
  DEFAULT_ICON_SIZE: "sm",
  DEFAULT_WRAPPER_CLASS: "d-flex w-full mt-3",
  DEFAULT_LEFT_CONTENT_CLASS: "text-muted",
} as const;

const ALIGNMENT = {
  BETWEEN: "between",
  RIGHT: "right",
  LEFT: "left",
  CENTER: "center",
} as const;

type AlignmentType = typeof ALIGNMENT[keyof typeof ALIGNMENT];

@Component
export default class SaveButton extends Vue {
  @Prop({ default: BUTTON_CONFIG.DEFAULT_TEXT })
  readonly buttonText!: string;

  @Prop({ default: BUTTON_CONFIG.DEFAULT_LOADING_TEXT })
  readonly loadingText!: string;

  @Prop({ default: "" })
  readonly leftContent!: string;

  @Prop({ default: false })
  readonly disabled!: boolean;

  @Prop({ default: false })
  readonly loading!: boolean;

  @Prop({ default: true })
  readonly showButton!: boolean;

  @Prop({ default: null })
  readonly showCondition!: boolean | null;

  @Prop({ default: false })
  readonly fixed!: boolean;

  @Prop({ default: ALIGNMENT.BETWEEN })
  readonly align!: AlignmentType;

  @Prop({ default: BUTTON_CONFIG.DEFAULT_CLASS })
  readonly buttonClass!: string;

  @Prop({ default: BUTTON_CONFIG.DEFAULT_WRAPPER_CLASS })
  readonly wrapperClass!: string;

  @Prop({ default: BUTTON_CONFIG.DEFAULT_LEFT_CONTENT_CLASS })
  readonly leftContentClass!: string;

  @Prop({ default: "" })
  readonly icon!: string;

  @Prop({ default: BUTTON_CONFIG.DEFAULT_ICON_SIZE })
  readonly iconSize!: string;

  @Prop({ default: BUTTON_CONFIG.DEFAULT_TYPE })
  readonly type!: string;

  get isDisabled(): boolean {
    return this.disabled || this.loading;
  }

  get isButtonVisible(): boolean {
    if (this.showCondition !== null) {
      return this.showCondition;
    }
    return this.showButton;
  }

  get buttonLabel(): string {
    return this.loading ? this.loadingText : this.buttonText;
  }

  get hasLeftContent(): boolean {
    return Boolean(this.$slots.left || this.leftContent);
  }

  get isRightAligned(): boolean {
    return this.align === ALIGNMENT.RIGHT;
  }

  get hasIcon(): boolean {
    return Boolean(this.icon && !this.loading);
  }

  get wrapperClasses() {
    return [
      this.wrapperClass,
      this.alignmentClass,
      {
        "save-button-fixed": this.fixed,
      },
    ];
  }

  get alignmentClass(): string {
    const alignmentMap: Record<AlignmentType, string> = {
      [ALIGNMENT.BETWEEN]: "justify-content-between",
      [ALIGNMENT.RIGHT]: "justify-content-end",
      [ALIGNMENT.LEFT]: "justify-content-start",
      [ALIGNMENT.CENTER]: "justify-content-center",
    };

    return alignmentMap[this.align] || alignmentMap[ALIGNMENT.BETWEEN];
  }

  handleClick(event: MouseEvent): void {
    if (this.isDisabled) {
      return;
    }

    this.$emit("save", event);
  }
}
